import { Text, Center, Button, Flex } from '@chakra-ui/react'
import { AvatarCircle } from '@/components/atoms/Avatar'

import { getEthereumAddress, getEthereumSignerAddress } from '@ninjablaze/sdk-ts'
import { useTranslation } from 'next-i18next/pages'
import { useSignInModal } from '../SigninHostModal'
import { useSession } from '@/context/SessionProvider'
import { StatusView } from './StatusView'
import { useState } from 'react'
import { StageTitle } from './StageTitle'
import { useAppToast } from '@/hooks/useAppToast'

export const Login = () => {
  const { context, navigateTo } = useSignInModal()
  const { t } = useTranslation()
  const { createSession } = useSession()
  const [isProcessing, setProcessing] = useState(false)
  const [error, setError] = useState(false)
  const { onTransactionError } = useAppToast()

  const handleLogin = async () => {
    setError(false)
    setProcessing(true)

    const createSessionResult = await createSession(context.wallet!, getEthereumAddress(context.user!.address!))

    if (createSessionResult.error) {
      onTransactionError(createSessionResult.error as any)
      setError(true)
      return
    }

    navigateTo(null as any)
  }

  if (isProcessing) {
    return (
      <StatusView
        error={error}
        isSuccess={false}
        retryCallback={() => {
          setError(false)
          handleLogin()
        }}
        backCallback={() => setProcessing(false)}
        provider={context.wallet || 'provider'}
      />
    )
  }

  return (
    <>
      <StageTitle title={t('messages.login')} backCallback={() => navigateTo('SignIn')} />
      <Flex flexDirection={'column'} justifyContent={'space-between'} height={'full'}>
        <Flex h={'full'} minH={'270px'} flexDirection={'column'} alignItems={'center'} justifyContent={'center'}>
          <Center mb="4">
            <AvatarCircle offset={8} size="2xl" src={context.user!.profile!.avatar} />
          </Center>
          <Center pb="1">
            <Text fontWeight="700" fontSize="xl">
              {context.user!.profile!.user_name}
            </Text>
          </Center>
          <Center pb="4">
            <Text fontWeight="700" fontSize="xs" color="ninja.200">
              {getEthereumSignerAddress(context.user!.address)}
            </Text>
          </Center>
        </Flex>
        <Button flexShrink={0} borderRadius="xl" w="full" h={'56px'} onClick={handleLogin}>
          {t('common.button.log-in')}
        </Button>
      </Flex>
    </>
  )
}
